import chroma from "chroma-js";
import * as d3 from "d3";

let baseColors = [];
let paletteConfig = {};

import csv from './data/palette-constructor-4.js';


export const palette = {

  initialize() {

    let csvData = d3.csvParse(csv);
    baseColors = convertCsvToColors(csvData);

  },

  getRawColorRange() {
    return baseColors;
  },


  getColorRange(baseColorIndex, selectionPattern, patternData={}) {

    let colorRange = [];

    let baseColorRange = this.getRawColorRange();

    let startRow = baseColorRange[baseColorIndex];

    let fourStepInitialIndex;

    startRow.forEach((col, j) => {

      let selectionIndex;

      if (selectionPattern === 'buhdegah-cat') {

        let columnsToUse = patternData.columnsToUse || 1;
        let rowsToStep = patternData.rowsToStep || 3;

        let alternate = Math.floor(j / (columnsToUse * rowsToStep)) % 2;
        alternate = (alternate === 0) ? 1 : -1;

        let increment = Math.floor((j % (columnsToUse * rowsToStep)) / columnsToUse);
        if (alternate < 0) {
          increment++;
        }

        selectionIndex = baseColorIndex + (increment * alternate);

        selectionIndex = selectionIndex % baseColorRange.length;
        if (selectionIndex < 0) {
          selectionIndex = baseColorRange.length + selectionIndex;
        }

      } else if (selectionPattern === 'alternating-steps') {
        if ((j >= 0 && j <= 3) || (j >= 7 && j <= 9)) {
          selectionIndex = baseColorIndex - (j % 3);
        } else {
          selectionIndex = baseColorIndex + (j % 3);
        }
        if (selectionIndex >= baseColorRange.length) {
          selectionIndex -= baseColorRange.length;
        }
        if (selectionIndex < 0) {
          selectionIndex = baseColorRange.length - Math.abs(selectionIndex);
        }
      } else if (selectionPattern === 'long-steps-down') {
        let step = Math.floor(j / 3);
        selectionIndex = baseColorIndex + step;

        if (selectionIndex >= baseColorRange.length) {
          selectionIndex -= baseColorRange.length;
        }
        if (selectionIndex < 0) {
          selectionIndex = baseColorRange.length - Math.abs(selectionIndex);
        }

      } else if (selectionPattern === 'long-steps-up') {
        let step = Math.floor(j / 3);
        selectionIndex = baseColorIndex - step;

        if (selectionIndex >= baseColorRange.length) {
          selectionIndex -= baseColorRange.length;
        }
        if (selectionIndex < 0) {
          selectionIndex = baseColorRange.length - Math.abs(selectionIndex);
        }

      } else if (selectionPattern === 'four-step') {
        //console.log("foxtrot…");
        let step = j % 4;
        selectionIndex = (baseColorIndex + step); // % baseColorRange.length;

        if (selectionIndex >= baseColorRange.length) {
          selectionIndex -= 4;
        }

        if (j === 0) {
          fourStepInitialIndex = baseColorIndex;
        }

      } else if (selectionPattern === 'flat') {
        selectionIndex = baseColorIndex;
      }
      //onsole.log(baseColorIndex, j, selectionIndex);
      colorRange.push(baseColorRange[selectionIndex][j]);

    });


    // Change the order a bit
    if (selectionPattern === 'four-step') {
      // console.log(fourStepInitialIndex);

      let breakpoints;

      if (fourStepInitialIndex <= 20) {
        breakpoints = [4,8];
      } else {
        breakpoints = [
          baseColorRange.length - fourStepInitialIndex,
          baseColorRange.length - fourStepInitialIndex + 4
        ];
      }

      colorRange = [
        ...colorRange.slice(0, breakpoints[0]),
        ...colorRange.slice(breakpoints[0], breakpoints[1]).reverse(),
        ...colorRange.slice(breakpoints[1], 9)
      ];
    }

    return colorRange;

  },


  registerPaletteConfig(paletteKey, selectionPattern) {
    paletteConfig[paletteKey] = selectionPattern;
  },
  getPaletteConfig(paletteKey) {
    return paletteConfig[paletteKey];
  }

}


function convertCsvToColors(csv) {

  //console.log(csv);

  let colors = [];
  //let cols = ["a", "b", "c", "d", "e", "f", "g", "h", "i"];
  let cols = [...Array(54).keys()];

  csv.forEach((row, i) => {

    colors[i] = [];
    let colorRow = colors[i];

    cols.forEach((col, j) => {

      let color = chroma.lab(+row[`${col  }.l`], +row[`${col  }.a`], +row[`${col  }.b`]);

      color.__lab = [row[`${col  }.l`], row[`${col  }.a`], row[`${col  }.b`]];
      color.__x = i;
      color.__y = j;

      colorRow.push(color);

    });

  });


  return colors;
}
